'use client';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

export const onSocialClick = (event: React.MouseEvent) => {
  logTmrEvent({
    logEvent: 'footer.networkClick',
    params: {
      social_link: event.currentTarget.getAttribute('href') ?? '',
      vk_id: -1,
    },
  });
};

export const onFooterClick = ({title}: {title: string}) => {
  logTmrEvent({
    logEvent: 'footer.click',
    params: {
      button_text: title,
      vk_id: -1,
    },
  });

  emitYmEvent({eventName: 'footer_click'});
};

export const footerTmrEvent = (
  logEvent: string,
  params: Record<string, unknown>,
) => {
  logTmrEvent({logEvent, params});
};
